import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getDocs, query, where, collection, onSnapshot, limit } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../components_root/ToastContext.jsx";
import product_icon from "../assets/product_icon.png"; 
import Website_data from './website_data.jsx'; 
import Meta_data from "./meta_data.jsx";
import { TbWindowMaximize, TbWindowMinimize } from "react-icons/tb";
import { VscDashboard } from "react-icons/vsc"; 
import { MdAccountCircle, MdHistory, MdOutlineAccountCircle, MdOutlineDatasetLinked } from "react-icons/md"; 
import { FaRegAddressCard } from "react-icons/fa";
export default function Website_root() {
    const [vouchers_masterdata, setVouchers_masterdata] = useState([]);
    const [IsLoading2, setIsLoading2] = useState(true);
    const servicetablename = "accountingfinancedb";
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("website");
    const [search, setSearch] = useState(window.location.search);
    const [categorynameTab, setCategorynameTab] = useState("website");
    const [collapsed, setCollapsed] = useState(false); 
    useEffect(() => {
        const params = new URLSearchParams(search);
        const tab = params.get("page");

        if (tab) {
            const t = tab.toLowerCase();
            setcategoryproductsTabInUrl(t);
            setCategorynameTab(t);
        } else {
            setCategorynameTab("website");
        }
    }, [search]);
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setCollapsed(true);
            } else {
                setCollapsed(false);
            }
        };

        // Run once on mount
        handleResize();

        // Attach resize listener
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    useEffect(() => {
        const updateSearch = () => setSearch(window.location.search);

        window.addEventListener("popstate", updateSearch);

        // Patch replaceState and pushState
        const patchHistory = (method) => {
            const original = window.history[method];
            window.history[method] = function () {
                const result = original.apply(this, arguments);
                window.dispatchEvent(new Event("urlchange"));
                return result;
            };
        };

        patchHistory("replaceState");
        patchHistory("pushState");

        window.addEventListener("urlchange", updateSearch);

        return () => {
            window.removeEventListener("popstate", updateSearch);
            window.removeEventListener("urlchange", updateSearch);
        };
    }, []);
    const Pages = {
        website: Website_data,
        meta:Meta_data,
    };
    const setcategoryproductsTabInUrl = (tab) => {
        const params = new URLSearchParams(window.location.search);
        params.set("page", tab);
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState({}, "", newUrl);
    };
    const ActivePage = Pages[categorynameTab] || null;
    const openEditVoucher = (uid) => {
        navigate(`/accounting?page=voucher&voucher_name=${uid}`, {
            state: { accountguid: uid }
        });
    };
    return (
        <div>
            <div className="products-body">
                <div className="productsmenu " >
                    <div onClick={() => setCollapsed(!collapsed)} className="menu-div b-bottom p-1" >
                        <table>
                            <tr>
                                <td width={40}   >
                                    <div className="menu-btn" >
                                        {collapsed ? <TbWindowMaximize className="icon-img" /> : <TbWindowMinimize className="icon-img" />}

                                    </div>
                                </td>
                                <td>
                                    {!collapsed && (

                                        <div className="menu-title bold text-h2 fcap"
                                        >
                                            Website
                                        </div>
                                    )}
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div title="Dashboard" className={`ui-items cursor b-bottom p-1 ${categorynameTab === "website" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                        onClick={() => {
                            setCategorynameTab("website");
                            setcategoryproductsTabInUrl("website");
                        }}
                    >
                        <table>
                            <tbody>
                                <tr>
                                    <td width={50} className="items-center"><VscDashboard className="icon-img" /></td>


                                    {collapsed === false && (
                                        <td className="text-h2 fcap">
                                            <>Dashboard</>
                                        </td>
                                    )}

                                </tr>

                                {collapsed === true &&
                                    (<tr>
                                        <td width={40} className="fcap text-h3 text-off">
                                            Dashboard
                                        </td>
                                    </tr>
                                    )}

                            </tbody>
                        </table>
                    </div>

                    <div title="Log History" className={`ui-items cursor b-bottom p-1 ${categorynameTab === "log-history" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                        onClick={() => {
                            setCategorynameTab("log-history");
                            setcategoryproductsTabInUrl("log-history");
                        }}
                    >
                        <table>
                            <tbody>
                                <tr>
                                    <td width={50} className="items-center"><MdHistory className="icon-img" /></td>


                                    {collapsed === false && (
                                        <td className="text-h2 fcap">
                                            <>Log History</>
                                        </td>
                                    )}

                                </tr>

                                {collapsed === true &&
                                    (<tr>
                                        <td width={40} className="fcap text-h3 text-off">
                                            Log
                                        </td>
                                    </tr>
                                    )}

                            </tbody>
                        </table>

                    </div>
                    <div title="Staff Accounts" className={`ui-items cursor b-bottom p-1 ${categorynameTab === "meta" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                        onClick={() => {
                            setCategorynameTab("meta");
                            setcategoryproductsTabInUrl("meta");
                        }}
                    >
                        <table>
                            <tbody>
                                <tr>
                                    <td width={50} className="items-center"><MdOutlineDatasetLinked  className="icon-img" /></td>


                                    {collapsed === false && (
                                        <td className="text-h2 fcap">
                                            <>Meta Data</>
                                        </td>
                                    )}

                                </tr>

                                {collapsed === true &&
                                    (<tr>
                                        <td width={40} className="fcap text-h3 text-off">
                                            Meta
                                        </td>
                                    </tr>
                                    )}

                            </tbody>
                        </table>

                    </div>
                    <div title="Company Accounts" className={`ui-items cursor b-bottom p-1 ${categorynameTab === "accounts-company" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                        onClick={() => {
                            setCategorynameTab("accounts-company");
                            setcategoryproductsTabInUrl("accounts-company");
                        }}
                    >
                        <table>
                            <tbody>
                                <tr>
                                    <td width={50} className="items-center"><MdOutlineAccountCircle className="icon-img" /></td>


                                    {collapsed === false && (
                                        <td className="text-h2 fcap">
                                            <>Accounts</>
                                        </td>
                                    )}

                                </tr>

                                {collapsed === true &&
                                    (<tr>
                                        <td width={40} className="fcap text-h3 text-off">
                                            Accounts
                                        </td>
                                    </tr>
                                    )}

                            </tbody>
                        </table>

                    </div>
                </div>

                <div className="products-container">
                    {ActivePage && <ActivePage />}
                </div>

            </div>
        </div>
    );
}
